'use client';

import { useConfig } from '@/app/contexts/ConfigContext';
import { checkUrlCountry } from '@/helpers';
import { LANGUAGE_OPTIONS } from '@/helpers/enums';

export default function TermsSpecificToCH() {
  const { config } = useConfig();

  return (
    <>
      {checkUrlCountry(
        config.SERVICE_URL_LINK,
        LANGUAGE_OPTIONS.CY
      ) && (
        <div style={{ color: config.theme.textColorDark }}>
          <p className='mb-4' style={{ color: config.theme.textColorDark }}>
            You are entitled to withdraw from this contract within 14 days from
            the day that you ordered the service without giving any reason for
            doing so. To exercise the right of withdrawal, you must inform us of
            your decision to withdraw from this contract by an unequivocal
            statement sent to
            {' ' + config.SERVICE_CONTACT_EMAIL}.
          </p>
          <p className='mb-4' style={{ color: config.theme.textColorDark }}>
            Our team will work hard to ensure you are satisfied with our
            services. If you are not satisfied with something we will try to
            find an acceptable solution. If you do not agree with the proposed
            solution or we refuse to satisfy your claim you are entitled to
            apply for alternative dispute resolution in accordance with EU
            regulations by starting at this
            <a
              href='https://ec.europa.eu/consumers/odr/'
              className='text-blue-600'
              style={{ color: config.theme.accentColorOne }}
            >
              {' '}
              link
            </a>
          </p>
          <p className='mb-4' style={{ color: config.theme.textColorDark }}>
            As a consumer, you have legal rights under EU law if our service
            does not meet the terms of the contract. You can request that we fix
            the service at no extra cost, seek a price reduction if the issue
            persists, or terminate the contract for a full refund if the problem
            is significant and cannot be resolved promptly. To exercise these
            rights, please contact our customer service team with details of the
            issue. These rights are in addition to your statutory rights under
            applicable law. For assistance, contact us using our contact
            details.
          </p>
        </div>
      )}
    </>
  );
}
